import React from "react";
import styled from "styled-components";
import { baseShade } from "../../../../../common/ui/Styles";
import { Account as AccountIcon } from "../features/account/icons";

interface AvatarProps {
  initials?: string | boolean;
  className?: string;
}

const Styled = {
  Container: styled.div`
    position: relative;
    background-color: ${baseShade(6)};
    border-radius: 100%;
    height: 64px;
    width: 64px;
  `,
  InnerContainer: styled.div`
    text-transform: capitalize;
    background-color: ${baseShade(9)};
    border-radius: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 56px;
    width: 56px;
    text-align: center;
    color: #ffffff;
    font-size: 28px;
    line-height: 2;
    svg {
      position: relative;
      top: 14px;
    }
  `,
};

const Avatar: React.FC<AvatarProps> = ({ className, initials }) => {
  return (
    <Styled.Container className={className} aria-hidden>
      <Styled.InnerContainer>
        {initials ? initials : <AccountIcon />}
      </Styled.InnerContainer>
    </Styled.Container>
  );
};

export default Avatar;
